function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#4B4B4B;}\n");

var SvgSimulatemin = function SvgSimulatemin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.594,0H131.406c-25.453,0-46.078,20.625-46.078,46.063v428c0,25.438,20.625,37.938,46.078,37.938h249.188 c25.438,0,46.078-12.5,46.078-37.938v-428C426.672,20.625,406.031,0,380.594,0z M402.281,474.063 c0,11.953-9.734,21.688-21.688,21.688H131.406c-11.969,0-21.688-9.734-21.688-21.688v-428c0-11.953,9.719-21.688,21.688-21.688 h249.188c11.953,0,21.688,9.734,21.688,21.688V474.063z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.219,
    y: 349.469,
    className: "st0",
    width: 32.516,
    height: 32.5,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.219,
    y: 414.469,
    className: "st0",
    width: 32.516,
    height: 32.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.219,
    y: 284.438,
    className: "st0",
    width: 32.516,
    height: 32.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.219,
    y: 219.438,
    className: "st0",
    width: 32.516,
    height: 32.5,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.234,
    y: 349.469,
    className: "st0",
    width: 32.516,
    height: 32.5,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.234,
    y: 414.469,
    className: "st0",
    width: 32.516,
    height: 32.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.234,
    y: 284.438,
    className: "st0",
    width: 32.516,
    height: 32.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.234,
    y: 219.438,
    className: "st0",
    width: 32.516,
    height: 32.5,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.25,
    y: 349.469,
    className: "st0",
    width: 32.516,
    height: 32.5,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.25,
    y: 414.469,
    className: "st0",
    width: 32.516,
    height: 32.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.25,
    y: 284.438,
    className: "st0",
    width: 32.516,
    height: 32.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.25,
    y: 219.438,
    className: "st0",
    width: 32.516,
    height: 32.5,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.266,
    y: 349.469,
    className: "st0",
    width: 32.516,
    height: 97.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.266,
    y: 284.438,
    className: "st0",
    width: 32.516,
    height: 32.516,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.266,
    y: 219.438,
    className: "st0",
    width: 32.516,
    height: 32.5,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.219,
    y: 73.141,
    className: "st0",
    width: 227.563,
    height: 89.391,
    style: {
      fill: "rgb(75, 75, 75)"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSimulatemin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Simulate.min.89910b7f.svg";
export { ForwardRef as ReactComponent };